const CCIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.3355 4.21045H5.89106C4.90439 4.21045 4.11328 5.11045 4.11328 6.21045V18.2104C4.11328 19.3104 4.90439 20.2104 5.89106 20.2104H18.3355C19.3133 20.2104 20.1133 19.3104 20.1133 18.2104V6.21045C20.1133 5.11045 19.3133 4.21045 18.3355 4.21045ZM11.2244 10.7104C11.2244 10.9904 11.0288 11.2104 10.7799 11.2104H10.3355C10.0866 11.2104 9.89106 10.9904 9.89106 10.7104H8.11328V13.7104H9.89106C9.89106 13.4304 10.0866 13.2104 10.3355 13.2104H10.7799C11.0288 13.2104 11.2244 13.4304 11.2244 13.7104V14.2104C11.2244 14.7604 10.8244 15.2104 10.3355 15.2104H7.66884C7.17995 15.2104 6.77995 14.7604 6.77995 14.2104V10.2104C6.77995 9.66039 7.17995 9.21039 7.66884 9.21039H10.3355C10.8244 9.21039 11.2244 9.66039 11.2244 10.2104V10.7104ZM17.0022 11.2104C17.2511 11.2104 17.4466 10.9904 17.4466 10.7104V10.2104C17.4466 9.66039 17.0466 9.21039 16.5577 9.21039H13.8911C13.4022 9.21039 13.0022 9.66039 13.0022 10.2104V14.2104C13.0022 14.7604 13.4022 15.2104 13.8911 15.2104H16.5577C17.0466 15.2104 17.4466 14.7604 17.4466 14.2104V13.7104C17.4466 13.4304 17.2511 13.2104 17.0022 13.2104H16.5577C16.3088 13.2104 16.1133 13.4304 16.1133 13.7104H14.3355V10.7104H16.1133C16.1133 10.9904 16.3088 11.2104 16.5577 11.2104H17.0022Z"
        fill="white"
      />
    </svg>
  );
};
export default CCIcon;
